import React from 'react';
import { unitIncludes, units } from '../../data/kit';
import { Highlight, SectionHeading } from '../ui/SectionHeading';
import { UnitIcon } from '../ui/UnitIcon';
const toneStyles = {
  mint: {
    visual: 'bg-mint',
    tile: 'bg-white',
    icon: 'stroke-petrol',
    label: 'text-teal'
  },
  white: {
    visual: 'bg-white border-b border-line',
    tile: 'bg-mint',
    icon: 'stroke-petrol',
    label: 'text-teal'
  },
  teal: {
    visual: 'bg-teal',
    tile: 'bg-white/15',
    icon: 'stroke-white',
    label: 'text-white'
  }
};
export function UnitsSection() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-205" data-mp="3g4h9kt3g4nnw">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-206" data-mp="325hti9u01h3c">
        <SectionHeading eyebrow="Inside the kit" title={<>
              Three complete units, <Highlight data-id="element-208" data-mp="3765ikpyo3nux">ready to print</Highlight>
            </>} data-id="element-207" data-mp="324znilhjboi8" />
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-209" data-mp="1qs5pnyy8oyh6">
          {units.map(unit => {
          const tone = toneStyles[unit.tone];
          return <article key={unit.id} className="flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-card" data-id="element-210" data-mp="qddcy1ivmkh2">
                <div className={`relative flex h-[190px] items-center justify-center ${tone.visual}`} data-id="element-211" data-mp="md39owmgy85w">
                  <span className={`absolute left-5 top-4 text-[11px] font-bold uppercase tracking-[.14em] ${tone.label}`} data-id="element-212" data-mp="108ovyw1bidum">
                    {unit.pages}
                  </span>
                  <div className={`h-[92px] w-[92px] rounded-[22px] p-5 ${tone.tile}`} data-id="element-213" data-mp="199n0dffo4ndq">
                    <UnitIcon id={unit.id} className={tone.icon} data-id="element-214" data-mp="159cu01nyruyc" />
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-215" data-mp="1j0hl2fd9nex2">
                  <h3 className="font-display text-[32px] font-extrabold uppercase leading-none text-petrol" data-id="element-216" data-mp="1e1wmekdnx3aq">{unit.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate" data-id="element-217" data-mp="1szypyukp1orz">{unit.body}</p>
                  <div className="mt-auto pt-5" data-id="element-218" data-mp="1o1neyginx886">
                    <p className="border-t border-line pt-4 text-[13px] font-bold text-teal" data-id="element-219" data-mp="1v3kcjhrzccru">{unit.focus}</p>
                  </div>
                </div>
              </article>;
        })}
        </div>
        <div className="mt-8 rounded-2xl bg-petrol px-6 py-6 sm:px-8" data-id="element-220" data-mp="2518644dune8f">
          <p className="text-xs font-bold uppercase tracking-[.18em] text-teal-light" data-id="element-221" data-mp="24zx0s04r9yf7">Every unit includes · 12 pages</p>
          <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-2" data-id="element-222" data-mp="2ertbqbrxxj0u">
            {unitIncludes.map(item => <li key={item} className="text-[15px] font-medium text-white" data-id="element-223" data-mp="2islm58cjttyp">
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}